export const commonFaqData = [
	{
		question: "Do you offer ongoing SEO and marketing services?",
		answer:
			"Yes, we provide comprehensive monthly SEO and digital marketing retainers. This includes content strategy, technical improvements, and performance analysis to ensure continuous growth.",
	},
	{
		question: "How does your web design process affect SEO?",
		answer:
			"Our web design is inherently SEO-friendly. We prioritize mobile responsiveness, fast loading speeds, and proper semantic structure during development to give you a head start in search rankings.",
	},
	{
		question: "Can you help with digital marketing campaigns?",
		answer:
			"Absolutely. We craft targeted digital marketing campaigns that align with your business goals, utilizing data-driven insights to maximize ROI and brand visibility.",
	},
];

export const generalFaqs = [
	{
		question: "Why should I choose CraftLayer for my business in Bangalore?",
		answer:
			"CraftLayer is a leading digital agency in Bangalore, specializing in custom web development and results-driven digital marketing. We combine technical expertise with creative strategy to deliver solutions that not only look great but also drive real business growth.",
	},
	{
		question: "What industries do you specialize in?",
		answer:
			"We work with a diverse range of industries including Real Estate, Healthcare, E-commerce, EdTech, and SaaS/Startups. our adaptable approach allows us to tailor strategies to your specific niche.",
	},
	{
		question: "How long does it take to build a website?",
		answer:
			"Timeline depends on complexity. A standard business website typically takes 2-4 weeks, while more complex e-commerce or custom web applications may take 6-10 weeks. We provide a detailed timeline during our initial consultation.",
	},
	...commonFaqData,
];
